<div class="text-center mx-7">
  <div style="height: 60vh" class="flex justify-content-center align-items-end">
    <img src="assets/FP-construction.png" alt="Logo" />
  </div>
  <h1 class="mt-4 block"> {{ 'SERVICE_PAGES.MAINTENANCE.TITLE' | translate }}</h1>
  <p> {{ 'SERVICE_PAGES.MAINTENANCE.MESSAGE' | translate }}</p>
</div>
